import { checkOauthCode } from "../services/hooks/preauth/checkAuthToken";
import { successfulLoginActions } from "../services/hooks/preauth/useLogin";
import { useAuthStore } from "@/client/services/state/authStore";
import { useEffect } from "react";
import { useHandoffParams } from "../services/hooks/preauth/useHandoffParams";
import { useLocalStorage } from "usehooks-ts";
import { useNavigate } from "react-router-dom";
import { useToastStore } from "../services/state/toastStore";
import { useTranslation } from "react-i18next";

export default function OauthTransition() {
  const { authConfig, setAuthConfig, logout } = useAuthStore();
  const [redirectLocation] = useLocalStorage("redirectLocation", null);
  const [angularRedirectLocation] = useLocalStorage("preRedirect", null);
  const navigate = useNavigate();
  const { setToast } = useToastStore();
  const { t } = useTranslation();
  const params = useHandoffParams();

  useEffect(() => {
    const navigateOauthHelper = navigate;

    const key = params.get("key");
    // The key names its user, so a landing may carry it without the identifier.
    if (key) {
      const tmp = async () => {
        const resultObj = await checkOauthCode(key, params.get("identifier"));
        if (!resultObj.result) {
          setToast({
            show: true,
            status: "error",
            title: t("saml.errors.unknown-origin"),
          });
          navigateOauthHelper("/login");
          return;
        }

        successfulLoginActions(
          resultObj.data,
          authConfig,
          setAuthConfig,
          angularRedirectLocation,
          redirectLocation,
          navigateOauthHelper
        );
      };
      tmp();
    } else {
      logout();
      navigateOauthHelper("/login");
    }
  }, []);
  return <div />;
}
